import React from 'react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { CheckCircle2, Shield, CreditCard, Zap, Lock } from 'lucide-react';
export function Hero() {
  return <section className="relative overflow-hidden pt-10 pb-16 px-4 md:pt-20 md:pb-24" data-id="element-200">
      {/* subtle radial glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-primary/10 blur-[150px] rounded-full pointer-events-none" data-id="element-201" />

      <div className="relative max-w-6xl mx-auto grid lg:grid-cols-2 gap-10 lg:gap-12 items-center" data-id="element-202">
        {/* Mockup — first on mobile for max visual impact */}
        <a href="#pricing" className="order-1 lg:order-2 relative flex justify-center group" aria-label="Ver oferta del Combo Completo HIIT Pro" data-id="element-203">
          {/* Sello destacado */}
          <div className="absolute -top-2 right-2 md:top-2 md:right-6 z-20 bg-primary text-black font-space-grotesk font-extrabold text-xs md:text-sm px-4 py-2 rounded-full shadow-[0_0_25px_rgba(249,168,212,0.6)] rotate-3" data-id="element-204">
            🔥 6 TOMOS + 6 BONOS GRATIS
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/9cq4WuwzcfMDphfFFmiwBg/MOCKUP.png" alt="Combo Completo HIIT Pro — 6 Tomos + 6 Bonos" className="w-full max-w-[460px] lg:max-w-none object-contain drop-shadow-[0_20px_60px_rgba(249,168,212,0.25)] transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-205" />
        </a>

        {/* Copy + CTA */}
        <div className="order-2 lg:order-1 text-center lg:text-left" data-id="element-206">
          {/* Headline */}
          <h1 className="text-4xl md:text-6xl font-extrabold mb-5 tracking-tight leading-[1.1]" data-id="element-207">
            DEJÁ DE IMPROVISAR{' '}
            <span className="text-primary" data-id="element-208">TUS CLASES DE HIIT</span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-2xl text-zinc-300 mb-7 leading-relaxed font-medium" data-id="element-209">
            300+ clases listas para aplicar durante todo el año.
          </p>

          {/* Quick bullets */}
          <div className="flex flex-wrap justify-center lg:justify-start gap-x-5 gap-y-2 mb-8 text-sm md:text-base text-zinc-200 font-medium" data-id="element-210">
            <span className="flex items-center gap-2" data-id="element-211">
              <CheckCircle2 className="w-5 h-5 text-primary" data-id="element-212" /> 52 semanas
              organizadas
            </span>
            <span className="flex items-center gap-2" data-id="element-213">
              <CheckCircle2 className="w-5 h-5 text-primary" data-id="element-214" /> Protocolos
              listos
            </span>
            <span className="flex items-center gap-2" data-id="element-215">
              <CheckCircle2 className="w-5 h-5 text-primary" data-id="element-216" /> Variantes por
              nivel
            </span>
            <span className="flex items-center gap-2" data-id="element-217">
              <CheckCircle2 className="w-5 h-5 text-primary" data-id="element-218" /> Acceso inmediato
            </span>
          </div>

          {/* Price */}
          <div className="flex items-end justify-center lg:justify-start gap-3 mb-4" data-id="element-219">
            <span className="text-zinc-500 line-through text-xl font-bold" data-id="element-220">
              $51.900
            </span>
            <span className="text-5xl md:text-6xl font-extrabold text-white leading-none" data-id="element-221">
              $19.990 <span className="text-xl text-zinc-500" data-id="element-222">ARS</span>
            </span>
          </div>

          {/* Urgency strip */}
          <div className="inline-flex items-center gap-2 bg-primary/15 border border-primary/30 rounded-full px-4 py-1.5 text-[11px] md:text-sm font-bold text-primary uppercase tracking-wider mb-6" data-id="element-223">
            🔥 Precio promocional de lanzamiento
          </div>

          {/* Countdown */}
          <div className="mb-7" data-id="element-224">
            <p className="text-xs md:text-sm font-bold text-zinc-400 uppercase tracking-widest mb-3 text-center lg:text-left" data-id="element-225">
              ⏰ La oferta finaliza en:
            </p>
            <div className="flex justify-center lg:justify-start" data-id="element-226">
              <Countdown data-id="element-227" />
            </div>
          </div>

          {/* CTA */}
          <Button href="#pricing" className="text-lg md:text-2xl py-5 px-8 w-full md:w-auto mb-6 shadow-[0_0_40px_rgba(249,168,212,0.3)]" data-id="element-228">
            QUIERO MI COMBO HIIT PRO
          </Button>

          {/* Trust microcopy */}
          <div className="flex flex-wrap items-center justify-center lg:justify-start gap-x-4 gap-y-2 text-xs md:text-sm text-zinc-400 font-medium" data-id="element-229">
            <span className="flex items-center gap-1.5" data-id="element-230">
              <Shield className="w-4 h-4 text-primary" data-id="element-231" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-232">
              <Zap className="w-4 h-4 text-primary" data-id="element-233" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-234">
              <CreditCard className="w-4 h-4 text-primary" data-id="element-235" /> Mercado Pago
            </span>
            <span className="flex items-center gap-1.5" data-id="element-236">
              <Lock className="w-4 h-4 text-primary" data-id="element-237" /> Pago seguro
            </span>
          </div>
        </div>
      </div>
    </section>;
}